import React, { useState, useEffect } from 'react';
import DataTable from 'react-data-table-component';
import GlassBox from "./glassbox";
import { Popover, Form } from 'react-bootstrap';
import { VscCommentUnresolved } from "react-icons/vsc";
import ReactDOM from 'react-dom';
import lambdaConfig from '../hooks/lambdaConfig';
import { configData } from "../config/systemconfigurationconstants";
import UseLambdaInvocations from '../hooks/useLambdaInvocations';
import OverlayTrigger from 'react-bootstrap/OverlayTrigger';
import Tooltip from 'react-bootstrap/Tooltip';
import { ToastContainer, toast } from "react-toastify";
import { TiInputChecked } from "react-icons/ti";
import { AiOutlineProduct } from "react-icons/ai";
import { PiBoundingBox } from "react-icons/pi";
import { RxBorderSplit } from "react-icons/rx";
import glassboxicon from '../assets/img/glassbox-1.svg';
import { useNavigate } from 'react-router-dom';




const DgGeneralInfoTable = ({ assetsData, glassboxjson, conditionjson, setConditionJson, getGeneralInfoDetailsForLoan, LoanStatus }) => {
    const [userRights] = useState(JSON.parse(localStorage.getItem("UserRights")));
    const [rolesAndRights] = useState(JSON.parse(localStorage.getItem("RolesAndRights")));
    const navigate = useNavigate();
    const TooltipTop = ({ id, children, title }) => (
        <OverlayTrigger placement='top' overlay={<Tooltip id={id}>{title}</Tooltip>}>
            <span>{children}</span>
        </OverlayTrigger>
    );
    const TooltipBottom = ({ id, children, title }) => (
        <OverlayTrigger placement='bottom' overlay={<Tooltip id={id}>{title}</Tooltip>}>
            <span>{children}</span>
        </OverlayTrigger>
    );
    const TooltipLeft = ({ id, children, title }) => (
        <OverlayTrigger placement='left' overlay={<Tooltip id={id}>{title}</Tooltip>}>
            <span>{children}</span>
        </OverlayTrigger>
    );
    const TooltipRight = ({ id, children, title }) => (
        <OverlayTrigger placement='right' overlay={<Tooltip id={id}>{title}</Tooltip>}>
            <span>{children}</span>
        </OverlayTrigger>
    )
    const { invokeLambda, loading, error } = UseLambdaInvocations();
    // const [isChecked, setIsChecked] = useState(false);
    // const [isToggleDisabled, setIsToggleDisabled] = useState(false);
    const [checkedRows, setCheckedRows] = useState({});
    const [assetsGridData, setAssetsGridData] = useState(null)
    const [scrollHeight, setScrollHeight] = useState('400px');  // Default scroll height
    const [waivedcommand, setWaivedcommand] = useState('');
    const [showPopover, setShowPopover] = useState(false);
    const [popoverTarget, setPopoverTarget] = useState(null);
    const [comment, setComment] = useState('');
    const [commenterror, setCommentError] = useState('');

    const [waivedconditionjson, setWaivedConditionJson] = useState({
        "LoanGuid": localStorage.getItem("loanGuid"),
        "Action": "Waive",
        "Details": []
    });
    useEffect(() => {
        if (assetsData?.Verbiage) {
            setAssetsGridData(assetsData?.Verbiage);
        } else {
            setAssetsGridData(null); // Handle case when assetsData is null
        }
    }, [assetsData]);
    // Define the headers explicitly
    const gridcolumns = [
        {
            name: 'Rule Source',
            selector: row => row.RS,
            sortable: true
        },
        {
            name: 'Condition Name',
            selector: row => row.CDNNM,
            sortable: true
        },
        {
            name: 'Condition',
            selector: row => row.CDN,
            sortable: true
        },
        {
            name: 'Result',
            selector: row => row.result,
            sortable: true,
            cell: row => {
                let icon;
                switch (row.RRSV) {
                    case 'Waived':
                        icon = <TooltipLeft title="Waived"><i style={{ color: 'red' }} className="ri-close-line"></i></TooltipLeft>;
                        break;
                    case 'Override':
                        icon = <TooltipLeft title="Condition is Open"><i style={{ color: 'green' }} className="ri-checkbox-circle-fill"></i></TooltipLeft>;
                        break;
                    case 'Cleared':
                        icon = <TooltipLeft title="Cleared"><i style={{ color: 'green' }} className="ri-check-line"></i></TooltipLeft>;
                        break;
                    case 'Reviewed':
                        icon = <TooltipLeft title="Reviewed"><i style={{ color: 'black' }} className="ri-information-line"></i></TooltipLeft>;
                        break;
                    case 'Cleared Condition':
                        icon = <TooltipLeft title="Success"><TiInputChecked style={{ color: 'green' }} /></TooltipLeft>;
                        break;
                    case 'Manual Review':
                        icon = <TooltipLeft title="Manual Review"><i className="ri-error-warning-line"></i></TooltipLeft>;
                        break;
                    case 'Fulfilled':
                        icon = <TooltipLeft title="Fulfilled"><i style={{ color: 'orange' }} className="ri-check-double-line"></i></TooltipLeft>;
                        break;
                    default:
                        icon = <TooltipLeft title="Condition is Open"><i style={{ color: 'green' }} className="ri-checkbox-circle-fill"></i></TooltipLeft>; // Default icon for unknown status
                }

                return (
                    <div>
                        {icon}
                    </div>
                );
            }
        },
        {
            name: 'Glassbox',
            selector: row => row.glassbox,
            sortable: true,
            cell: row => {
                const hasFieldInfo = row.FieldInfo !== null;

                return (
                    <div>
                        {(hasFieldInfo && hasRightsToGlassBox()) ? (
                            <TooltipLeft title="View data trace">
                                <svg
                                    id="Layer_1"
                                    className="glassboxone"
                                    role="button"
                                    tabIndex="0"
                                    aria-label="View data trace"
                                    onClick={() => openInGlassBoxNewWindow(row)}
                                    xmlns="http://www.w3.org/2000/svg"
                                    viewBox="0 0 122.88 122.56"
                                >
                                    {/* Your SVG path */}
                                    <path d="M6.57,0H47.35a6.55,6.55,0,0,1,5.08,2.42,6.59,6.59,0,0,1,1.11,2,6.49,6.49,0,0,1,.39,2.2v40.6a6.63,6.63,0,0,1-4.14,6.1,6.47,6.47,0,0,1-2.44.48H6.57a6.4,6.4,0,0,1-2.41-.48,6.29,6.29,0,0,1-2.1-1.34A6.46,6.46,0,0,1,.55,49.76,6.27,6.27,0,0,1,0,47.17V6.57a6.43,6.43,0,0,1,.43-2.3,6.41,6.41,0,0,1,1.19-2L1.89,2A6.52,6.52,0,0,1,3.86.6,6.65,6.65,0,0,1,6.57,0ZM89.72,62.4a26.24,26.24,0,0,1,10.11,2l.07,0a25.4,25.4,0,0,1,4.54,2.44,25.66,25.66,0,0,1,4,3.27,26.08,26.08,0,0,1,3.3,4,26.79,26.79,0,0,1,2.44,4.58,25.29,25.29,0,0,1,1.5,5,26,26,0,0,1,.51,5.16,26.84,26.84,0,0,1-.27,3.82,27.37,27.37,0,0,1-.83,3.74,26,26,0,0,1-1.15,3.13,27.22,27.22,0,0,1-1.41,2.74l9.95,10.85a1.57,1.57,0,0,1-.09,2.23l-7.45,6.81a1.66,1.66,0,0,1-1.11.39,1.58,1.58,0,0,1-1.09-.51l-9.5-10.45a27.06,27.06,0,0,1-2.73,1.41,24.79,24.79,0,0,1-3.11,1.17h0a26.69,26.69,0,0,1-7.64,1.13,26.5,26.5,0,0,1-10.12-2l-.08,0A26.56,26.56,0,0,1,75,110.83a26.14,26.14,0,0,1-7.28-7.29,26.44,26.44,0,0,1-2.45-24.8l0-.08a27,27,0,0,1,2.44-4.53A26.42,26.42,0,0,1,75,66.86a26.15,26.15,0,0,1,4.58-2.45,26,26,0,0,1,10.12-2Zm14.51,11.94a21.13,21.13,0,0,0-3.12-2.56,20.83,20.83,0,0,0-3.55-1.9l-.06,0a19.41,19.41,0,0,0-3.8-1.14,20.74,20.74,0,0,0-4-.39,21.16,21.16,0,0,0-4,.39,20.46,20.46,0,0,0-3.83,1.16,20.83,20.83,0,0,0-3.55,1.9,20.55,20.55,0,0,0-3.11,2.56l-.07.06a21.26,21.26,0,0,0-2.52,3.09A20.7,20.7,0,0,0,70.75,81l0,.06a21,21,0,0,0-1.14,3.81,20.74,20.74,0,0,0-.38,4,20.38,20.38,0,0,0,.39,4,20.45,20.45,0,0,0,3,7.37,20.63,20.63,0,0,0,2.56,3.12l0,0a21.1,21.1,0,0,0,3.11,2.55,19.93,19.93,0,0,0,3.53,1.89A20.56,20.56,0,0,0,85.7,109a20.86,20.86,0,0,0,8,0,19.83,19.83,0,0,0,3.84-1.16,21.12,21.12,0,0,0,3.54-1.9,20.52,20.52,0,0,0,3.12-2.56l.06-.06a20.24,20.24,0,0,0,2.52-3.09,21.08,21.08,0,0,0,1.88-3.51l0-.07a20.31,20.31,0,0,0,1.13-3.8,20.74,20.74,0,0,0,.38-4,21,21,0,0,0-.38-4A21.33,21.33,0,0,0,108.69,81a20.74,20.74,0,0,0-1.9-3.54,21.25,21.25,0,0,0-2.56-3.12ZM6.57,62.07H47.35a6.52,6.52,0,0,1,2.82.64,6.67,6.67,0,0,1,3.37,3.73,6.49,6.49,0,0,1,.39,2.2v40.6a6.56,6.56,0,0,1-.53,2.57A6.66,6.66,0,0,1,51.9,114a6.72,6.72,0,0,1-4.55,1.85H6.57a6.6,6.6,0,0,1-2.41-.48A6.45,6.45,0,0,1,2.06,114a6.67,6.67,0,0,1-1.51-2.17A6.3,6.3,0,0,1,0,109.24V68.64a6.43,6.43,0,0,1,.43-2.3,6.57,6.57,0,0,1,1.19-2l.27-.27a6.67,6.67,0,0,1,2-1.38,6.49,6.49,0,0,1,2.71-.6Zm40.79,6.55H6.57l0,0,0,40.63c3.49,0,40.79,0,40.82,0,0-3.43,0-40.62,0-40.63ZM69.51,0h40.78a6.55,6.55,0,0,1,2.82.64,6.72,6.72,0,0,1,2.26,1.78,6.35,6.35,0,0,1,1.1,2,6.49,6.49,0,0,1,.39,2.2v40.6a6.56,6.56,0,0,1-.53,2.57,6.41,6.41,0,0,1-1.5,2.16,6.55,6.55,0,0,1-4.54,1.85H69.51a6.48,6.48,0,0,1-2.42-.48A6.39,6.39,0,0,1,65,51.93a6.68,6.68,0,0,1-2.06-4.76V6.57a6.66,6.66,0,0,1,1.63-4.31L64.82,2a6.58,6.58,0,0,1,4.69-2Zm40.78,6.55H69.51l0,0V47.2c3.5,0,40.79,0,40.83,0,0-3.43,0-40.61,0-40.63Zm-62.93,0H6.57l0,0,0,40.63c3.49,0,40.79,0,40.82,0,0-3.43,0-40.61,0-40.63Z" />
                                </svg>
                            </TooltipLeft>
                        ) : (
                            <TooltipLeft title="No data available">
                                <svg
                                    id="Layer_1"
                                    className="glassboxtwo"
                                    aria-label="No data available"
                                    xmlns="http://www.w3.org/2000/svg"
                                    viewBox="0 0 122.88 122.56"
                                >
                                    {/* Your SVG path */}
                                    <path d="M6.57,0H47.35a6.55,6.55,0,0,1,5.08,2.42,6.59,6.59,0,0,1,1.11,2,6.49,6.49,0,0,1,.39,2.2v40.6a6.63,6.63,0,0,1-4.14,6.1,6.47,6.47,0,0,1-2.44.48H6.57a6.4,6.4,0,0,1-2.41-.48,6.29,6.29,0,0,1-2.1-1.34A6.46,6.46,0,0,1,.55,49.76,6.27,6.27,0,0,1,0,47.17V6.57a6.43,6.43,0,0,1,.43-2.3,6.41,6.41,0,0,1,1.19-2L1.89,2A6.52,6.52,0,0,1,3.86.6,6.65,6.65,0,0,1,6.57,0ZM89.72,62.4a26.24,26.24,0,0,1,10.11,2l.07,0a25.4,25.4,0,0,1,4.54,2.44,25.66,25.66,0,0,1,4,3.27,26.08,26.08,0,0,1,3.3,4,26.79,26.79,0,0,1,2.44,4.58,25.29,25.29,0,0,1,1.5,5,26,26,0,0,1,.51,5.16,26.84,26.84,0,0,1-.27,3.82,27.37,27.37,0,0,1-.83,3.74,26,26,0,0,1-1.15,3.13,27.22,27.22,0,0,1-1.41,2.74l9.95,10.85a1.57,1.57,0,0,1-.09,2.23l-7.45,6.81a1.66,1.66,0,0,1-1.11.39,1.58,1.58,0,0,1-1.09-.51l-9.5-10.45a27.06,27.06,0,0,1-2.73,1.41,24.79,24.79,0,0,1-3.11,1.17h0a26.69,26.69,0,0,1-7.64,1.13,26.5,26.5,0,0,1-10.12-2l-.08,0A26.56,26.56,0,0,1,75,110.83a26.14,26.14,0,0,1-7.28-7.29,26.44,26.44,0,0,1-2.45-24.8l0-.08a27,27,0,0,1,2.44-4.53A26.42,26.42,0,0,1,75,66.86a26.15,26.15,0,0,1,4.58-2.45,26,26,0,0,1,10.12-2Zm14.51,11.94a21.13,21.13,0,0,0-3.12-2.56,20.83,20.83,0,0,0-3.55-1.9l-.06,0a19.41,19.41,0,0,0-3.8-1.14,20.74,20.74,0,0,0-4-.39,21.16,21.16,0,0,0-4,.39,20.46,20.46,0,0,0-3.83,1.16,20.83,20.83,0,0,0-3.55,1.9,20.55,20.55,0,0,0-3.11,2.56l-.07.06a21.26,21.26,0,0,0-2.52,3.09A20.7,20.7,0,0,0,70.75,81l0,.06a21,21,0,0,0-1.14,3.81,20.74,20.74,0,0,0-.38,4,20.38,20.38,0,0,0,.39,4,20.45,20.45,0,0,0,3,7.37,20.63,20.63,0,0,0,2.56,3.12l0,0a21.1,21.1,0,0,0,3.11,2.55,19.93,19.93,0,0,0,3.53,1.89A20.56,20.56,0,0,0,85.7,109a20.86,20.86,0,0,0,8,0,19.83,19.83,0,0,0,3.84-1.16,21.12,21.12,0,0,0,3.54-1.9,20.52,20.52,0,0,0,3.12-2.56l.06-.06a20.24,20.24,0,0,0,2.52-3.09,21.08,21.08,0,0,0,1.88-3.51l0-.07a20.31,20.31,0,0,0,1.13-3.8,20.74,20.74,0,0,0,.38-4,21,21,0,0,0-.38-4A21.33,21.33,0,0,0,108.69,81a20.74,20.74,0,0,0-1.9-3.54,21.25,21.25,0,0,0-2.56-3.12ZM6.57,62.07H47.35a6.52,6.52,0,0,1,2.82.64,6.67,6.67,0,0,1,3.37,3.73,6.49,6.49,0,0,1,.39,2.2v40.6a6.56,6.56,0,0,1-.53,2.57A6.66,6.66,0,0,1,51.9,114a6.72,6.72,0,0,1-4.55,1.85H6.57a6.6,6.6,0,0,1-2.41-.48A6.45,6.45,0,0,1,2.06,114a6.67,6.67,0,0,1-1.51-2.17A6.3,6.3,0,0,1,0,109.24V68.64a6.43,6.43,0,0,1,.43-2.3,6.57,6.57,0,0,1,1.19-2l.27-.27a6.67,6.67,0,0,1,2-1.38,6.49,6.49,0,0,1,2.71-.6Zm40.79,6.55H6.57l0,0,0,40.63c3.49,0,40.79,0,40.82,0,0-3.43,0-40.62,0-40.63ZM69.51,0h40.78a6.55,6.55,0,0,1,2.82.64,6.72,6.72,0,0,1,2.26,1.78,6.35,6.35,0,0,1,1.1,2,6.49,6.49,0,0,1,.39,2.2v40.6a6.56,6.56,0,0,1-.53,2.57,6.41,6.41,0,0,1-1.5,2.16,6.55,6.55,0,0,1-4.54,1.85H69.51a6.48,6.48,0,0,1-2.42-.48A6.39,6.39,0,0,1,65,51.93a6.68,6.68,0,0,1-2.06-4.76V6.57a6.66,6.66,0,0,1,1.63-4.31L64.82,2a6.58,6.58,0,0,1,4.69-2Zm40.78,6.55H69.51l0,0V47.2c3.5,0,40.79,0,40.83,0,0-3.43,0-40.61,0-40.63Zm-62.93,0H6.57l0,0,0,40.63c3.49,0,40.79,0,40.82,0,0-3.43,0-40.61,0-40.63Z" />
                                </svg>
                            </TooltipLeft>
                        )}
                    </div>
                );
            }
        },
        {
            name: 'Status',
            selector: row => row.status,
            sortable: true,
            cell: row => {
                const isChecked = checkedRows[row.ERRSID] !== undefined ? checkedRows[row.ERRSID] : (row.RRSV === "Cleared");

                return (
                    <div>
                        <div className="d-flex justify-content-center align-items-center">
                            <TooltipLeft title="Manual Review"> <div className="me-1">
                                <div className="form-check">
                                    <input
                                        className="form-check-input primary"
                                        type="checkbox"
                                        value=""
                                        id={`flexCheckDefault-${row.ERRSID}`}
                                        checked={isChecked}
                                        disabled={row.RRSV === "Reviewed" || LoanStatus === "Completed" || !hasRightsToConditionStatusChange()}
                                        onChange={(e) => {
                                            const newCheckedState = e.target.checked;
                                            handleCheckboxChange(row.ERRSID, newCheckedState);
                                        }} // Update checked state
                                    />
                                </div>
                            </div></TooltipLeft>
                            <div className="me-1">
                                <OverlayTrigger
                                    trigger="click"
                                    placement="left"
                                    rootClose={true}
                                    show={showPopover && popoverTarget === row.ERRSID}
                                    onToggle={() => handleToggle(row.ERRSID)}
                                    overlay={
                                        <Popover id="popover-basic" style={{ width: '300px', height: '215px' }}>
                                            <Popover.Header as="h3">Comments</Popover.Header>
                                            <Popover.Body>
                                                <Form.Control as="textarea" rows={4} placeholder="Input Comments" onChange={(e) => addingWaivedNoted(row.ERRSID, e)} />
                                                {commenterror && <div className="text-danger mt-1">{commenterror}</div>}
                                                <div className='d-flex flex-row-reverse mt-3'>
                                                    {hasRightsToSave() && (<button type="button" className="btn btn-primary btn-sm" onClick={callingWaivedCondition}>Save</button>)}
                                                    <button type="button" className="btn btn-secondary btn-sm me-1" onClick={handleClose}>Cancel</button>
                                                </div>
                                            </Popover.Body>
                                        </Popover>
                                    }
                                >
                                    <Form.Check
                                        type="switch"
                                        id={`status-switch-${row.ERRSID}`}
                                        label={row.status ? '' : ''}
                                        checked={row.RRSV === "Waived"}
                                        onChange={(e) => handleToggleChange(row.ERRSID, e.target.checked)} // Handle toggle change
                                        disabled={isChecked || row.RRSV === "Reviewed" || LoanStatus === "Completed" || !hasRightsToConditionStatusChange()} // Disable toggle if checkbox is checked
                                    />
                                </OverlayTrigger>
                            </div>
                            <div className="me-1">
                                <VscCommentUnresolved disabled={row.RRSV === "Reviewed"} />
                            </div>
                        </div>
                    </div>
                );
            }
        },
        // {
        //     name: 'Status',
        //     selector: row => row.status,
        //     sortable: true,
        //     cell: row => (
        //         <div>
        //             <div class="d-flex justify-content-center align-items-center">
        //                 <div class="">
        //                     <div class="form-check">
        //                         <input className="form-check-input primary"
        //                             type="checkbox"
        //                             value=""
        //                             id={`flexCheckDefault-${row.ERRSID}`}
        //                             checked={isChecked}
        //                             onChange={handleCheckboxChange} />
        //                     </div>
        //                 </div>
        //                 <div class="">
        //                     {/* <div class="form-check form-switch">
        //         <input class="form-check-input" type="checkbox" role="switch" id="flexSwitchCheckDefault" />

        //      </div> */}
        //                     <OverlayTrigger
        //                         trigger="click"
        //                         placement="left"
        //                         overlay={
        //                             <Popover id="popover-basic">
        //                                 <Popover.Header as="h3">Comments</Popover.Header>
        //                                 <Popover.Body>
        //                                     <Form.Control size="sm" type="text" placeholder="Input Comments" />
        //                                     <div className='d-flex flex-row-reverse mt-3'>
        //                                         <button type="button" class="btn btn-primary btn-sm">Save</button>
        //                                         <button type="button" class="btn btn-secondary btn-sm me-1">Cancel</button>
        //                                     </div>
        //                                 </Popover.Body>
        //                             </Popover>
        //                         }
        //                     >
        //                         <Form.Check
        //                             type="switch"
        //                             id={`status-switch-${row.ERRSID}`}
        //                             label={row.status ? '' : ''}
        //                             checked={row.status}
        //                             onChange={handleToggleChange}
        //                             disabled={isToggleDisabled}
        //                         />
        //                     </OverlayTrigger>
        //                 </div>
        //                 <div class="">
        //                     <VscCommentUnresolved />
        //                 </div>
        //             </div>
        //         </div>
        //     )
        // },
        {
            name: 'Comments',
            selector: row => row.comments,
            sortable: true,
            cell: row => (
                <div>
                    {row.Notes}
                </div>
            )
        }
    ];
    const openInGlassBoxNewWindow = (rowdata) => {
        localStorage.setItem('categoryID', rowdata.CID);
        localStorage.setItem('clickedRule', JSON.stringify(rowdata));
        console.log(rowdata, 'rowdata');
        const width = window.innerWidth;
        const height = window.innerHeight;
        // const dummyUrl = '';
        const dummyUrl = '/glassbox-viewer';
        const newWindow = window.open(dummyUrl, 'GlassBoxWindow', `width=${width},height=${height}`);
        // Load Bootstrap CSS
        const linkBootstrap = newWindow.document.createElement('link');
        linkBootstrap.rel = 'stylesheet';
        linkBootstrap.href = 'https://cdn.jsdelivr.net/npm/bootstrap@5.3.3/dist/css/bootstrap.min.css';
        newWindow.document.head.appendChild(linkBootstrap);
        // Load Remix Icon CSS
        const linkRemixIcon = newWindow.document.createElement('link');
        linkRemixIcon.rel = 'stylesheet';
        linkRemixIcon.href = 'https://cdn.jsdelivr.net/npm/remixicon@2.5.0/fonts/remixicon.css';
        newWindow.document.head.appendChild(linkRemixIcon);
        // Add external CSS file
        const externalCssLink = newWindow.document.createElement('link');
        externalCssLink.rel = 'stylesheet';
        externalCssLink.href = '/loan-import.css';  // Replace with your external CSS file URL
        // externalCssLink.href = `${window.location.origin}/loan-import.css`;
        // externalCssLink.href = 'http://localhost:3001/loan-import.css';

        newWindow.document.head.appendChild(externalCssLink);
        const script = newWindow.document.createElement('script');
        script.src = 'https://cdn.jsdelivr.net/npm/bootstrap@5.3.3/dist/js/bootstrap.bundle.min.js';
        newWindow.document.body.appendChild(script);
        if (newWindow) {
            newWindow.document.title = 'Glassbox Viewer';
            newWindow.document.body.innerHTML = '<div id="root"></div>';
            ReactDOM.render(
                <GlassBox />
                , newWindow.document.getElementById('root'));
        }
    };
    // const openInGlassBoxNewWindow = (rowdata) => {
    //     const width = window.innerWidth;
    //     const height = window.innerHeight;
    //     const dummyUrl = '/glassbox-viewer'; // Path to open

    //     const newWindow = window.open(dummyUrl, 'GlassBoxWindow', `width=${width},height=${height}`);

    //     const sendMessage = () => {
    //         if (newWindow) {
    //             newWindow.postMessage({
    //                 glass: rowdata, // assuming rowdata includes ConditionDetails
    //                 categoryID: rowdata.CID,
    //                 clickedRule: rowdata
    //             }, window.location.origin);
    //         }
    //     };

    //     // Retry until the new window is ready
    //     const interval = setInterval(() => {
    //         if (newWindow && newWindow.document.readyState === 'complete') {
    //             sendMessage();
    //             clearInterval(interval);
    //         }
    //     }, 500);
    // };
    useEffect(() => {
        const handleResize = () => {
            const width = window.innerWidth;
            if (width === 1920) {
                setScrollHeight('504px');
            }
            else if (width === 1680) {
                setScrollHeight('471px');
            }
            else if (width === 1600) {
                setScrollHeight('321px');
            }
            else if (width === 1280) {
                setScrollHeight('451px');
            }
            else {
                setScrollHeight('400px');
            }
        };
        handleResize();
        window.addEventListener('resize', handleResize);
        return () => window.removeEventListener('resize', handleResize);
    }, []);
    const handleCheckboxChange = (rowId, isChecked) => {
        setCheckedRows(prev => ({
            ...prev,
            [rowId]: isChecked // Update the state for the specific row
        }));

        // Update the conditionjson based on checkbox changes
        const existingDetailIndex = conditionjson.Details.findIndex(detail => detail.RuleConditionsId === rowId);

        if (existingDetailIndex !== -1) {
            // If it exists, update the ActionResult
            const updatedDetails = [...conditionjson.Details];
            updatedDetails[existingDetailIndex].ActionResult = isChecked ? 1 : 0;
            setConditionJson(prev => ({
                ...prev,
                Action: "Clear", // Update the Action property
                Details: updatedDetails
            }));
        } else {
            // If it does not exist, push a new object into the Details array
            setConditionJson(prev => ({
                ...prev,
                Details: [
                    ...prev.Details,
                    {
                        "RuleConditionsId": rowId,
                        "ActionResult": isChecked ? 1 : 0,
                        "Notes": null
                    }
                ]
            }));
        }

    };

    const handleToggleChange = async (rowId, isActive) => {
        // if (isActive) {
        setShowPopover(true);
        // } else {
        //     setShowPopover(false);

        // }
        console.log(`${rowId}'s status is now ${isActive ? 'Active' : 'Inactive'}`);
        // Initialize the conditionjson object

        // Check if the rowId already exists in the Details array
        const existingDetailIndexforwaive = waivedconditionjson.Details.findIndex(detail => detail.RuleConditionsId === rowId);

        if (existingDetailIndexforwaive !== -1) {
            // If it exists, update the ActionResult
            waivedconditionjson.Details[existingDetailIndexforwaive].ActionResult = isActive ? 1 : 0;
        } else {
            // If it does not exist, push a new object into the Details array
            waivedconditionjson.Details.push({
                "RuleConditionsId": rowId,
                "ActionResult": isActive ? 1 : 0,
                "Notes": ''
            });
        }


    };
    // const handleCheckboxChange = (e) => {
    //     const checked = e.target.checked;
    //     setIsChecked(checked);
    //     setIsToggleDisabled(checked); // Disable toggle when checkbox is checked
    // };

    // const handleToggleChange = (e) => {
    //     // console.log(`${row.name}'s status is now ${e.target.checked ? 'Active' : 'Inactive'}`);
    // };
    const addingWaivedNoted = (rowId, e) => {
        setComment(e.target.value);
        setCommentError(''); // Clear error when user starts typing
        setWaivedcommand(e.target.value);
        // waivedconditionjson.Notes = e.target.value;
        const existingDetailIndexforwaive = waivedconditionjson.Details.findIndex(detail => detail.RuleConditionsId === rowId);
        waivedconditionjson.Details[existingDetailIndexforwaive].Notes = e.target.value; // Update Notes
    }
    const callingWaivedCondition = async () => {
        if (comment.trim() === '') {
            setCommentError('Comment cannot be empty.');
            return;
        }
        try {
            const parsedBody = await invokeLambda(configData.CONDITION_ACTIONS, {
                ...lambdaConfig,
                SecurityToken: localStorage.getItem('SecurityToken'),
                ConditionJSON: waivedconditionjson,
            });
            if (parsedBody.Status) {
                toast.success("Condition Waived Sucessfully", {
                    position: "bottom-center",
                    autoClose: 2000,
                    hideProgressBar: true,
                    closeOnClick: true,
                    pauseOnHover: true,
                    draggable: true,
                    progress: undefined,
                    theme: "colored",
                });
            } else {
                toast.error("Condition Unwaived Sucessfull", {
                    position: "bottom-center",
                    autoClose: 2000,
                    hideProgressBar: true,
                    closeOnClick: true,
                    pauseOnHover: true,
                    draggable: true,
                    progress: undefined,
                    theme: "colored",
                });
            }
            await getGeneralInfoDetailsForLoan();
        } catch (err) {
            // Handle error if needed
        }
        handleClose();
    }
    const handleClose = () => {
        setCommentError('');
        setComment(''); // optional: clear textarea too
        setShowPopover(false);
        setPopoverTarget(null);
    };
    const handleToggle = (target) => {
        if (popoverTarget === target) {
            setShowPopover(!showPopover);
        } else {
            setShowPopover(true);
            setPopoverTarget(target);
        }
    };
    const screenWidth = window.innerWidth;
    let minHeight;

    if (screenWidth == 1920) {
        minHeight = '534px';
    } else if (screenWidth == 1680) {
        minHeight = '504px';
    } else if (screenWidth == 1600) {
        minHeight = '354px';
    } else if (screenWidth == 1280) {
        minHeight = '474px';
    } else {
        minHeight = 'calc(100vh - 413px)';
    }
    const customStyles = {

        table: {
            style: {
                //minHeight: 'calc(100vh - 280px)', 
                minHeight,
                backgroundColor: 'white',
                overflowY: 'auto',
            },
        },


    };
    // const hasRightsToClearConditions = () => {
    //     let rightID = rolesAndRights.AllRights.find(el => el.RightType.trim() == "CLEAR_CONDITIONS")?.RightId;
    //     return userRights.find(el => el.RightId == rightID).RightValue == 1 ? true : false;
    // }


    const hasRightsToConditionStatusChange = () => {

        if (rolesAndRights !== null) {

            let rightID = rolesAndRights.AllRights.find(el => el.RightType.trim() == "CONDITION_STATUS_CHANGE")?.RightId;

            if (userRights.some(el => el.RightId == rightID)) {

                return userRights.find(el => el.RightId == rightID).RightValue == 1 ? true : false;

            }

        }

    }
    const hasRightsToGlassBox = () => {

        if (rolesAndRights !== null) {

            let rightID = rolesAndRights.AllRights.find(el => el.RightType.trim() == "GLASSBOX")?.RightId;

            if (userRights.some(el => el.RightId == rightID)) {

                return userRights.find(el => el.RightId == rightID).RightValue == 1 ? true : false;

            }

        }

    }
    const hasRightsToSave = () => {

        if (rolesAndRights !== null) {

            let rightID = rolesAndRights.AllRights.find(el => el.RightType.trim() == "SAVE")?.RightId;

            if (userRights.some(el => el.RightId == rightID)) {

                return userRights.find(el => el.RightId == rightID).RightValue == 1 ? true : false;

            }

        }

    }


    return (
        <>
            {assetsGridData === null ? (
                <p style={{ textAlign: 'center', display: 'flex', alignItems: 'center', justifyContent: 'center', height: 'calc(100vh - 365px)' }}>No data available</p> // Display this if assetsGridData is null
            ) : (
                <DataTable
                    columns={gridcolumns}
                    data={assetsGridData}
                    pagination
                    paginationPerPage={5}
                    paginationRowsPerPageOptions={[5, 10, 15, 20, 25, 30]}
                    dense
                    striped
                    responsive
                    fixedHeader
                    pointerOnHover
                    // fixedHeaderScrollHeight={scrollHeight}
                    customStyles={customStyles}
                    noDataComponent={<p>No data available</p>}
                />
            )}
        </>
    );
}
export default DgGeneralInfoTable